import {
  faFacebook,
  faGithub,
  faInstagram,
  faLinkedinIn,
  faPaypal,
  faSkype,
  faTiktok,
  faTwitch,
  faWeixin,
  faWhatsapp,
  faXTwitter,
  faYelp,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/pro-regular-svg-icons';
import { faBrowser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { CardUrl } from 'types';

interface UrlTypeIconProps {
  type: CardUrl['type'];
}

const UrlTypeIcon: React.FC<React.PropsWithChildren<UrlTypeIconProps>> = ({ type }) => {
  switch (type) {
    case 'calendly':
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-icon="calendly"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          style={{ width: '1em', verticalAlign: '-.125em' }}
        >
          <path
            fill="currentColor"
            d="M424 61.12h-63.04v-8.56a12.4 12.4 0 10-24.72 0v8.56H172.4v-8a12.4 12.4 0 00-24.8 0v8H84.72a40 40 0 00-40 40V422a40 40 0 0040 40H424a40 40 0 0040-40V101.12a40 40 0 00-40-40zm14.56 361.44a16 16 0 01-16 16H85.28a16 16 0 01-16-16V100.8a16 16 0 0116-16h62.32v29.36a12.4 12.4 0 0024.8 0V84.8H336v29.04a12.4 12.4 0 0024.72 0V84.8h61.84a16 16 0 0116 16zM318.32 320.8a4.4 4.4 0 001.28-3.12 4.64 4.64 0 00-4.56-4.56 4.56 4.56 0 00-3.2 1.36 68.96 68.96 0 01-44 15.52 64.88 64.88 0 01-66.88-62.56 64.88 64.88 0 0166.88-62.64 69.52 69.52 0 0143.52 15.12 4.48 4.48 0 003.2 1.36 4.56 4.56 0 004.56-4.56 4.8 4.8 0 00-1.28-3.12 79.12 79.12 0 00-49.68-17.28c-42.08 0-76.16 32-76.16 71.36s34.08 71.36 76.16 71.36a78.4 78.4 0 0050.08-17.76z"
          ></path>
        </svg>
      );
    case 'discord':
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fab"
          data-icon="discord"
          className="svg-inline--fa fa-discord fa-w-14 "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M297.216 243.2c0 15.616-11.52 28.416-26.112 28.416-14.336 0-26.112-12.8-26.112-28.416s11.52-28.416 26.112-28.416c14.592 0 26.112 12.8 26.112 28.416zm-119.552-28.416c-14.592 0-26.112 12.8-26.112 28.416s11.776 28.416 26.112 28.416c14.592 0 26.112-12.8 26.112-28.416.256-15.616-11.52-28.416-26.112-28.416zM448 52.736V512c-64.494-56.994-43.868-38.128-118.784-107.776l13.568 47.36H52.48C23.552 451.584 0 428.032 0 398.848V52.736C0 23.552 23.552 0 52.48 0h343.04C424.448 0 448 23.552 448 52.736zm-72.96 242.688c0-82.432-36.864-149.248-36.864-149.248-36.864-27.648-71.936-26.88-71.936-26.88l-3.584 4.096c43.52 13.312 63.744 32.512 63.744 32.512-60.811-33.329-132.244-33.335-191.232-7.424-9.472 4.352-15.104 7.424-15.104 7.424s21.248-20.224 67.328-33.536l-2.56-3.072s-35.072-.768-71.936 26.88c0 0-36.864 66.816-36.864 149.248 0 0 21.504 37.12 78.08 38.912 0 0 9.472-11.52 17.152-21.248-32.512-9.728-44.8-30.208-44.8-30.208 3.766 2.636 9.976 6.053 10.496 6.4 43.21 24.198 104.588 32.126 159.744 8.96 8.96-3.328 18.944-8.192 29.44-15.104 0 0-12.8 20.992-46.336 30.464 7.68 9.728 16.896 20.736 16.896 20.736 56.576-1.792 78.336-38.912 78.336-38.912z"
          ></path>
        </svg>
      );
    case 'facebook':
      return <FontAwesomeIcon icon={faFacebook} />;
    case 'github':
      return <FontAwesomeIcon icon={faGithub} />;
    case 'instagram':
      return <FontAwesomeIcon icon={faInstagram} />;
    case 'threads':
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fab"
          data-icon="threads"
          className="svg-inline--fa fa-threads "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"
          />
        </svg>
      );
    case 'linkedin':
      return <FontAwesomeIcon icon={faLinkedinIn} />;
    case 'company_url':
    case 'org':
      return <FontAwesomeIcon icon={faBrowser} />;
    case 'paypal':
      return <FontAwesomeIcon icon={faPaypal} />;
    case 'skype':
      return <FontAwesomeIcon icon={faSkype} />;
    case 'snapchat':
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fab"
          data-icon="snapchat"
          className="svg-inline--fa fa-snapchat fa-w-16"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 496 512"
        >
          <path
            fill="currentColor"
            d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm169.5 338.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C183.1 100 230.7 96 244.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
          ></path>
        </svg>
      );
    case 'telegram':
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fab"
          data-icon="telegram-plane"
          className="svg-inline--fa fa-telegram-plane fa-w-14 "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
        >
          <path
            fill="currentColor"
            d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
          ></path>
        </svg>
      );
    case 'tiktok':
      return <FontAwesomeIcon icon={faTiktok} />;
    case 'twitch':
      return <FontAwesomeIcon icon={faTwitch} />;
    case 'twitter':
      return <FontAwesomeIcon icon={faXTwitter} />;
    case 'venmo':
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-icon="venmo"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          style={{ width: '1em', verticalAlign: '-.125em' }}
        >
          <path
            fill="currentColor"
            d="M432.356 47.091c15.17 25.284 22.123 51.2 22.123 84.07 0 104.928-89.442 240.83-162.133 336.592H126.42L60.05 69.847 205.431 55.94l35.082 283.18c32.869-53.412 73.323-137.798 73.323-195.002 0-31.29-5.373-52.78-13.906-70.48l132.425-26.548z"
          ></path>
        </svg>
      );
    case 'cashapp':
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-icon="cashapp"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          style={{ width: '1em', verticalAlign: '-.125em' }}
        >
          <path
            fill="currentColor"
            d="M339.761 190.4c4 4 10.641 4 14.4 0l20-20.8c4.241-4 4-11.2-.48-15.52a157.829 157.829 0 00-53.76-30.72l6.321-30.4c1.36-6.64-3.6-12.88-10.24-12.88h-38.72c-2.421.026-4.76.883-6.622 2.426a10.553 10.553 0 00-3.618 6.054l-5.6 27.04c-51.52 2.64-95.2 28.8-95.2 82.4 0 46.399 36.08 66.32 74.24 79.999 36.08 13.76 55.2 18.88 55.2 38.24 0 19.921-19.04 31.601-47.2 31.601-25.6 0-52.48-8.561-73.28-29.44a10.403 10.403 0 00-11.344-2.26 10.403 10.403 0 00-3.376 2.26l-21.6 21.6a10.879 10.879 0 000 15.36c16.8 16.559 38.08 28.559 62.336 35.2l-5.92 28.559c-1.36 6.641 3.52 12.8 10.16 12.881l38.8.32a10.563 10.563 0 0010.4-8.48l5.6-27.119c61.984-4.16 99.744-38.321 99.744-88.162 0-45.92-37.6-65.28-83.2-81.039-26.08-9.681-48.64-16.32-48.64-36.24 0-19.36 21.04-27.04 42.16-27.04 26.88 0 52.72 11.12 69.6 26.32l-.16-.16z"
          ></path>
        </svg>
      );
    case 'wechat':
      return <FontAwesomeIcon icon={faWeixin} />;
    case 'whatsapp':
      return <FontAwesomeIcon icon={faWhatsapp} />;
    case 'yelp':
      return <FontAwesomeIcon icon={faYelp} />;
    case 'youtube':
      return <FontAwesomeIcon icon={faYoutube} />;
    case 'signal':
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-icon="signal"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          style={{ width: '1em', verticalAlign: '-.125em' }}
        >
          <path
            fill="currentColor"
            d="M194.351 7.794l5.606 23.182c-22.418 5.595-44.035 14.389-64.05 26.38l-12.41-20.385c22.017-13.19 46.035-23.182 70.854-29.177zm123.298 0l-5.606 23.182c22.418 5.595 44.036 14.389 64.051 26.38l12.41-20.385c-22.018-13.19-46.037-23.182-70.855-29.177zm-281.02 115.91c-13.21 21.982-23.219 45.964-29.223 70.744l23.218 5.596c5.604-22.383 14.411-43.966 26.42-63.95l-20.415-12.39zM23.819 256c0-11.59.8-23.182 2.802-34.772L3.002 217.63C-1 243.21-1 268.79 3.002 294.37l23.619-3.598c-2.002-11.59-2.802-23.182-2.802-34.772zm364.685 219.03l-12.41-20.385c-20.015 11.99-41.633 21.183-64.451 26.78l5.605 23.181c25.22-6.396 49.238-16.387 71.256-29.576zM488.18 256c0 11.59-.8 23.182-2.801 34.772l23.618 3.598c4.003-25.58 4.003-51.16 0-76.74l-23.618 3.598c2 11.59 2.8 23.182 2.8 34.772zm16.414 61.552l-23.218-5.596c-5.606 22.782-14.412 44.366-26.421 64.35l20.415 12.391c13.212-22.384 23.218-46.364 29.224-71.145zm-213.768 167.87c-23.218 3.597-46.436 3.597-69.654 0l-3.603 23.58c25.62 3.997 51.24 3.997 76.86 0l-3.603-23.58zm152.12-91.93c-14.012 18.786-30.425 35.173-49.24 49.162l14.412 19.185c20.816-15.187 38.83-33.574 54.443-53.957l-19.616-14.39zm-49.24-324.146c18.815 13.989 35.228 30.376 49.24 49.161l19.215-14.388c-15.213-20.784-33.627-38.77-54.043-53.958l-14.412 19.185zM69.054 118.507c14.011-18.785 30.424-35.172 49.238-49.161l-14.41-19.185C83.064 65.349 65.05 83.735 49.838 104.119l19.215 14.388zm406.317 5.196l-20.415 12.39c12.009 19.985 21.215 41.568 26.82 64.351l23.22-5.596c-6.407-25.18-16.413-49.162-29.625-71.145zM221.173 26.58c23.218-3.597 46.436-3.597 69.654 0l3.603-23.581C268.81-1 243.19-1 217.57 2.998l3.603 23.581zM81.463 468.233l-49.638 11.593 11.609-49.562-23.618-5.596-11.61 49.562c-3.202 12.79 4.804 25.979 18.014 28.778 3.603.798 7.206.798 10.809 0l49.639-11.192-5.204-23.583zM25.02 403.484l23.218 5.596 8.006-34.372c-11.61-19.585-20.416-40.768-26.02-62.752l-23.219 5.596c5.205 21.183 13.21 41.567 23.619 60.752l-5.604 25.18zm112.087 51.96l-34.427 7.994 5.605 23.182 25.22-5.996c19.214 10.392 39.63 18.386 60.846 23.582l5.606-23.182c-22.018-5.196-43.235-13.989-62.85-25.58zM256 48.163C141.11 48.162 47.837 141.29 47.837 256c0 39.17 11.21 77.54 32.025 110.313l-20.015 85.535 85.266-19.985c97.277 61.151 225.776 31.975 287.024-65.15 61.249-97.124 32.025-225.423-65.251-286.576C333.66 59.354 295.23 48.162 256 48.162z"
          ></path>
        </svg>
      );
    case 'link':
      return (
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="far"
          data-icon="link"
          className="svg-inline--fa fa-link fa-w-16 "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
        >
          <path
            fill="currentColor"
            d="M314.222 197.78c51.091 51.091 54.377 132.287 9.75 187.16-6.242 7.73-2.784 3.865-84.94 86.02-54.696 54.696-143.266 54.745-197.99 0-54.711-54.69-54.734-143.255 0-197.99 32.773-32.773 51.835-51.899 63.409-63.457 7.463-7.452 20.331-2.354 20.486 8.192a173.31 173.31 0 0 0 4.746 37.828c.966 4.029-.272 8.269-3.202 11.198L80.632 312.57c-32.755 32.775-32.887 85.892 0 118.8 32.775 32.755 85.892 32.887 118.8 0l75.19-75.2c32.718-32.725 32.777-86.013 0-118.79a83.722 83.722 0 0 0-22.814-16.229c-4.623-2.233-7.182-7.25-6.561-12.346 1.356-11.122 6.296-21.885 14.815-30.405l4.375-4.375c3.625-3.626 9.177-4.594 13.76-2.294 12.999 6.524 25.187 15.211 36.025 26.049zM470.958 41.04c-54.724-54.745-143.294-54.696-197.99 0-82.156 82.156-78.698 78.29-84.94 86.02-44.627 54.873-41.341 136.069 9.75 187.16 10.838 10.838 23.026 19.525 36.025 26.049 4.582 2.3 10.134 1.331 13.76-2.294l4.375-4.375c8.52-8.519 13.459-19.283 14.815-30.405.621-5.096-1.938-10.113-6.561-12.346a83.706 83.706 0 0 1-22.814-16.229c-32.777-32.777-32.718-86.065 0-118.79l75.19-75.2c32.908-32.887 86.025-32.755 118.8 0 32.887 32.908 32.755 86.025 0 118.8l-45.848 45.84c-2.93 2.929-4.168 7.169-3.202 11.198a173.31 173.31 0 0 1 4.746 37.828c.155 10.546 13.023 15.644 20.486 8.192 11.574-11.558 30.636-30.684 63.409-63.457 54.733-54.735 54.71-143.3-.001-197.991z"
          ></path>
        </svg>
      );
    default:
      return <FontAwesomeIcon icon={faLink} />;
  }
};

export default UrlTypeIcon;
